<template>
  <v-card :disabled="isProcessing" :loading="isProcessing">
    <template v-slot:progress>
      <v-progress-linear
        absolute
        color="success"
        height="4"
        indeterminate
      ></v-progress-linear>
    </template>
    <v-tabs v-model="tab" class="crm-color" left dark icons-and-text>
      <v-tabs-slider></v-tabs-slider>
      <v-tab href="#tab-1">
        <v-toolbar-title>{{ $t("DEAL_DOCUMENT_TYPES.TITLE") }}</v-toolbar-title>
      </v-tab>
      <v-spacer></v-spacer>
      <div class="buttons-tab">
        <v-btn
          v-if="hasPermissions('deal-document-types-create')"
          class="mr-4 success"
          :disabled="isProcessing"
          @click="handleCreateClick"
        >
          {{ $t("GENERAL.LABELS.CREATE_BUTTON") }}
        </v-btn>
      </div>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item value="tab-1">
        <v-card flat>
          <v-card-text class="pa-0">
            <Table
              v-if="userStatePrepared"
              ref="deal-document-types-table"
              height="500"
              name="deal-document-types-table"
              :headers="headers"
              :blink-row-item-key="blinkRowItemKey"
              :server-data-options="{
                method: tableItemsMethod,
              }"
              :items-per-page="100"
              :loading="isProcessing"
              dense
              fixed-header
              multi-sort
              filterable
            >
              <template
                v-for="(header, index) in headers"
                v-slot:[`item.${header.value}`]="{ item }"
              >
                <span
                  v-if="header.value === 'options'"
                  :key="index"
                  class="d-flex align-center justify-center flex-nowrap"
                >
                  <v-btn
                    icon
                    color="indigo"
                    :to="{ name: 'deal-document-types-view', params: { id: item.item.id } }"
                    @click="rememberTableRow(item.item.id)"
                  >
                    <v-icon dark>mdi-eye</v-icon>
                  </v-btn>
                </span>
                <template v-else-if="header.value === 'is_system'">
                  <v-chip
                    :key="index"
                    x-small
                    :color="item.value ? 'primary' : 'grey'"
                    dark
                  >
                    {{
                      item.value
                        ? $t("DEAL_DOCUMENT_TYPES.SYSTEM")
                        : $t("DEAL_DOCUMENT_TYPES.CUSTOM")
                    }}
                  </v-chip>
                </template>
                <template v-else-if="header.value === 'required'">
                  <v-icon
                    :key="index"
                    :color="item.value ? 'success' : 'grey'"
                  >
                    {{ item.value ? "mdi-check" : "mdi-close" }}
                  </v-icon>
                </template>
                <template v-else>
                  {{ item.value || "-" }}
                </template>
              </template>
            </Table>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import Table from "@/views/partials/v-table/Table.vue";
import userStateService from "@/common/userState.service.js";
import { GET_DEAL_DOCUMENT_TYPES } from "@/store/dealDocumentTypes.module";

export default {
  name: "ListDealDocumentTypes",
  components: {
    Table,
  },
  data() {
    return {
      tableName: "deal-document-types-table",
      blinkRowItemKey: null,
      userStatePrepared: false,
      tab: "tab-1",
      isProcessing: false,
      tableItemsMethod: GET_DEAL_DOCUMENT_TYPES,
      headers: [
        {
          text: "#",
          value: "id",
          align: "center",
          width: "6%",
        },
        {
          text: this.$t("GENERAL.LABELS.NAME"),
          value: "name",
          align: "center",
          width: "28%",
        },
        {
          text: this.$t("DEAL_DOCUMENT_TYPES.SLUG"),
          value: "slug",
          align: "center",
          width: "22%",
        },
        {
          text: this.$t("DEAL_DOCUMENT_TYPES.REQUIRED"),
          value: "required",
          align: "center",
          width: "12%",
        },
        {
          text: this.$t("DEAL_DOCUMENT_TYPES.TYPE"),
          value: "is_system",
          align: "center",
          width: "12%",
        },
        {
          text: this.$t("GENERAL.TABLE.OPTIONS_COLUMN"),
          value: "options",
          sortable: false,
          align: "center",
          width: "20%",
        },
      ],
    };
  },
  mounted() {
    this.blinkRowItemKey = userStateService.getState(
      `table-state.${this.tableName}.blinkRowItemKey`,
      null
    );
    this.userStatePrepared = true;
  },
  methods: {
    handleCreateClick() {
      this.$router.push({ name: "deal-document-types-create" });
    },
    rememberTableRow(id) {
      userStateService.setState(
        `table-state.${this.tableName}.blinkRowItemKey`,
        id
      );
    },
  },
};
</script>
